import React from "react";

import { COLORS } from "../../../utils/colors";

import FooterInfo from "./FooterInfo";
import PrivacyCopyrightInfo from "./PrivacyCopyrightInfo";

const Footer = () => {
  return (
    <footer className="m-footer">
      <div className="_wr">
        <div className="_w">
          <FooterInfo />
          <PrivacyCopyrightInfo />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
